import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function TableRow({ children, type = 'body' }) {
    return (_jsx("tr", { className: cn('group', {
            'hover:bg-bg-subtle/50 bg-surface': type === 'body',
            '[tbody>&:first-child>td:first-child]:rounded-tl-2xl': type === 'body',
            '[tbody>&:first-child>td:last-child]:rounded-tr-2xl': type === 'body',
            '[tbody>&:last-child>td:first-child]:rounded-bl-2xl': type === 'body',
            '[tbody>&:last-child>td:last-child]:rounded-br-2xl': type === 'body',
        }), children: children }));
}
